import { useCallback } from 'react';

import { setData, setLoading } from 'redux/reducers/meteorologyAgroCultureIndexAreaReducer';
import { useLazyGetCultureIndexAreaMapDataQuery } from 'services/api/Meteorology/Agro/CultureIndex/Area';
import { CultureIndexAreaMap } from 'types/Meteorology/Agro/CultureIndex/Area/map';
import { ResponseError } from 'services/api/base';
import { store } from 'redux/store';

export default function useMapData() {
  const [trigger, { isFetching }] = useLazyGetCultureIndexAreaMapDataQuery();

  const triggerMapDataRequest = useCallback(async (map: CultureIndexAreaMap) => {
    store.dispatch(setLoading({ id: map.id, isLoading: true }));

    const response = await trigger({
      culture: map.params.culture?.name as string,
      forecastDate: map.params.forecastDate as string,
      periodStart: map.params.periodStart as string,
      periodEnd: map.params.periodEnd as string,
      local: null,
    });

    if ('data' in response) {
      store.dispatch(setData({ id: map.id, data: response.data, error: undefined }));
    } else if ('error' in response) {
      const error = {
        title: (response.error as ResponseError).data,
        message: (response.error as ResponseError).description || '',
      };
      store.dispatch(setData({ id: map.id, data: undefined, error }));
    }
  }, [trigger]);

  return {
    triggerMapDataRequest,
    isFetching,
  };
}
